import React from 'react';
import classnames from 'classnames';
import s from './FeedSidebar.scss';
const FeedSidebar = ({ children, className })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", null, children));
FeedSidebar.displayName = 'FeedSidebar';
export default FeedSidebar;

//# sourceMappingURL=FeedSidebar.js.map